function CartPageCtrl($http, toaster, $translate, cartService, $scope) {
  const ctrl = this;
  ctrl.$onInit = function () {
    ctrl.refreshCart();
    cartService.addCallback('remove', ctrl.refreshCart);
    cartService.addCallback('add', ctrl.refreshCart);
    cartService.addCallback('clear', ctrl.refreshCart);
    $scope.$on('$destroy', () => {
      cartService.removeCallback('remove', ctrl.refreshCart);
      cartService.removeCallback('add', ctrl.refreshCart);
      cartService.removeCallback('clear', ctrl.refreshCart);
    });
  };
  ctrl.getUrlShareCart = function () {
    $http.get('cart/getUrlShareCart').then(response => {
      if (response.data) {
        ctrl.urlShareCart = response.data;
      } else {
        toaster.pop('error', $translate.instant('Js.Cart.CouldNotCopyLink'));
      }
    });
  };
  ctrl.copyToClipboard = function () {
    const input = document.getElementById('urlShareCart');
    input.select();
    if (document.execCommand('copy')) {
      toaster.pop('success', '', $translate.instant('Js.Cart.LinkCopied'));
    } else {
      toaster.pop('error', '', $translate.instant('Js.Cart.CouldNotCopyLink'));
    }
  };
  ctrl.refreshCart = function () {
    cartService.getData().then(data => {
      ctrl.cartData = data;
    });
  };
}
CartPageCtrl.$inject = ["$http", "toaster", "$translate", "cartService", "$scope"];
export default CartPageCtrl;